import styled from "styled-components"

const DebugLabel = styled.span`
  background: ${({ theme }) => theme.sun};
  border-radius: 4px;
  color: ${({ theme }) => theme.white};
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  margin: 0 0 0 5px;
  opacity: 0.5;
  padding: 4px;
  vertical-align: middle;
`

export default DebugLabel
